// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__20oFP","title":"FrontImage_title__2Ki_D"};